import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { PaginationPageEvent, ListParams, Res, SubscriptionList } from 'src/app/models';
import { ApiSubscriptionsService, DialogModalService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-subscriptions-list',
  templateUrl: './subscriptions-list.component.html',
  styleUrls: ['./subscriptions-list.component.css']
})
export class SubscriptionsListComponent implements OnInit {

  paginationOutput: PaginationPageEvent;
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  paginationInput: any;
  listParams: ListParams;
  language: string;
  loading: boolean;
  subscriptionsList: SubscriptionList[] = [];

  constructor(
    public ngProgress: NgProgress,
    private notification: NotificationService,
    private apiSubscriptionsService: ApiSubscriptionsService,
    private dialogModal: DialogModalService,
    private languageService: LanguageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    
    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.subscriptionsList = [];

    this.setListParams();

    this.apiSubscriptionsService.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getSubscriptions: ', response);

      if (response != null) {

        this.subscriptionsList = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
* 
*/
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: ''
      },
      object: 'uroles_in_orgs',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
  * 
  * @param ids 
  */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiSubscriptionsService.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.subscriptionsList.filter(val => val.checked).map(({ id }) => id))];
    this.onDelete(ids);
  }

  /**
  * 
  */
  onCreate() {

    this.router.navigate(['subscriptions', 'create']);
  }

  /**
  * 
  * @param event PaginationPageEvent
  */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.subscriptionsList[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.subscriptionsList.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.subscriptionsList.length == 0) return false;

    return this.subscriptionsList.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.subscriptionsList.length;
    let pc = this.subscriptionsList.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.subscriptionsList.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }
}
